import axios from 'axios'

import { apiUrl } from '@/config'

const state = {
  event: null
}

const getters = {}

const mutations = {
  setEvent (state, event) {
    state.event = event
  },
}

const actions = {
  async getEvent (context, eventId) {
    return axios.get(`${apiUrl}/api/events/${eventId}`)
      .then(response => { context.commit('setEvent', response.data) })
      .catch(e => { console.log(e) })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
